import type { ComponentType } from 'react';
import { createElement } from 'react';

import { NUMBERED_GAMES_COUNT } from '../../../../config/constants';

import { RankNumber } from './RankNumber';

type RankProps = { className?: string };

function makeRankComponent(rank: number): ComponentType<RankProps> {
  return function RankNumberItem({ className }: RankProps) {
    return createElement(RankNumber, { className, rank });
  };
}

export const RANK_NUMBERS: ComponentType<RankProps>[] = Array.from({ length: NUMBERED_GAMES_COUNT }, (_, i) =>
  makeRankComponent(i + 1),
);
